<script>
    import { writable } from 'svelte/store'
    import { getContext, onDestroy, createEventDispatcher } from 'svelte'
    import Button from './Button.svelte'
    import { AddCircle, InfoOutline } from '../Icons'
    import Typography from './Typography.svelte'
    import TertiaryButton from './TertiaryButton.svelte'
    import InputFileItem from './InputFileItem.svelte'
    import Alert from './Alert.svelte'
    import Picture from '../../../assets/pictures/z21-add-policy.svg'
    import { API_URL } from '$lib/conf'
    let formData = getContext('formData')
    const toast = getContext('toast')
    export let name = null
    export let value = null
    export let valid = true
    export let label = null
    export let required = false
    export let disabled = false
    export let validation = _ => true
    export let multi = false
    export let progress = 0
    export let style = ''
    export let type = 'default'
    export let allowExt = ['pdf']
    export let maxFileSize = 0
    export let maxFiles = 0
    export let upload = false
    export let buttonText = 'Cargar'
    export let headers = {}
    export let legend = 'Seleccioná el documento que querés cargar'
    export let plusButtonLabel = 'Agregar más archivos'
    export let endpoint = null
    export let errMsg = null
    export let preview = false
    export let validationFileItem = null
    const dispatch = createEventDispatcher()
    let current = {}
    let objInput
    let files
    // if (value instanceof Array){}else{value = []}
    const filesList = writable([])
    
    const Multiplos = {
        k: 10**3,
        M: 10**6,
        G: 10**9,
        T: 10**12
    }
    
    const Units = {
        b: 1/8,
        B: 1
    }

    let defaultValidation = (item) => {
        let ret = true
        if(multi && maxFiles && value.length > maxFiles) {
            toast && toast.error('Se alcanzó el número máximo de documentos permitidos.')
            ret = false
        }
        if(maxFileSize) {
            let maxSize = solveSize(maxFileSize)
            console.log({maxSize})
            if(item.size > maxSize) {
                toast && toast.error(`Los documentos no pueden superar el tamaño de ${getSize(maxSize, 'MB')}.`)
                ret = false
            }
        }
        return ret
    }
    
    const solveSize = (i) => {
        let rgx = /(?<n>\d+\.?\d+?)\s*(?<m>[A-z])(?<u>[A-z])/
        if(typeof i === 'number') return i
        if(typeof i === 'string') {
            let match = rgx.exec(i)
            if (match && match.groups) {
                let {n, m, u} = match.groups
                if ([m in Multiplos, u in Units].every(x => x)) {
                    return parseFloat(n) * Multiplos[m] * Units[u]
                } else {
                    throw new Error('Unknow multiplo or unit memory.')
                }
            } else {
                throw new Error('Invalid format.')
            }
        }
    }
    const getSize = (bytes, format='kB') => {
        let rgx = /(?<m>[A-z])(?<u>[A-z])/
        let match = rgx.exec(format)
        if (match && match.groups) {
            let {m, u} = match.groups
            if ([m in Multiplos, u in Units].every(x => x)) {
                return `${(bytes / Multiplos[m]) / Units[u]}${format}`
            } else {
                throw new Error('Unknow multiplo or unit memory.')
            }
        } else {
            throw new Error('Invalid format.')
        }
    }

    function loadFile() {
        objInput.click()
    }
    function deleteItemBuilder(index) {
        return function () {
            filesList.update((allItems) => {
                return allItems.filter((x) => {
                    return x.id !== index
                })
            })
        }
    }
    function progressHandler(e) {
        progress = e.loaded / e.total
    }
    function completeHandler(e) {
        let tmp = e.target.responseText
        try {
            current = JSON.parse(tmp)
        } catch {
            current = tmp
        }
        let statusRequest = e.target.status
        let ok = statusRequest >= 200 && statusRequest < 300
        if (multi && ok) {
            filesList.update((n) => [
                ...n,
                {
                    id: crypto.randomUUID(),
                    fileId:
                        typeof current == 'object' && 'fileId' in current
                            ? current['fileId']
                            : null,
                    filename: files[0].name,
                },
            ])
        } else if (ok) {
            filesList.update((_) => [
                {
                    id: crypto.randomUUID(),
                    fileId:
                        typeof current == 'object' && 'fileId' in current
                            ? current['fileId']
                            : null,
                    filename: files[0].name,
                },
            ])
        }
        progress = 0
        upload = false
        if(!ok) {
            $filesList = []
            toast && toast.error(current?.msg || current?.message || current)
            return
        }
    }
    function errorHandler(e) {
        upload = false
        toast && toast.error('Ocurrió un error al intentar subir el documento.')
    }
    function abortHandler(e) {
        upload = false
        toast && toast.error('Ocurrió un error al intentar subir el documento.')
    }
    async function uploadFile(e) {
        let formdata = new FormData()
        // e.target.files
        if (files && endpoint && files?.length) {
            let ffile = files[0]
            let ffValidations = defaultValidation(ffile) && (typeof validationFileItem == 'function' ?  validationFileItem(ffile) : true)
            if(typeof ffValidations == 'string' || (ffValidations === false)) {
                if(validationFileItem) toast && toast.error(ffValidations || 'Error al validar el archivo.')
                return
            }
            formdata.append('file', ffile)
            formdata.append('title', ffile.name)
            let mfetch = new XMLHttpRequest()
            mfetch.upload.addEventListener('progress', progressHandler, false)
            mfetch.addEventListener('load', completeHandler, false)
            mfetch.addEventListener('error', errorHandler, false)
            mfetch.addEventListener('abort', abortHandler, false)
            mfetch.addEventListener(
                'onreadystatechange',
                (e) => {
                    if (mfetch.readyState === XMLHttpRequest.DONE) {
                        const status = mfetch.status
                        console.log(mfetch.responseText)
                    }
                },
                false
            )
            mfetch.open('POST', endpoint)
            Object.values(headers).forEach(([k, v]) => {
                mfetch.setRequestHeader(k, v)
            })
            await mfetch.send(formdata)
            upload = true
        }
    }
    $: if (files) {
        uploadFile()
    }
    $: if (value) {
        valid = value && validation ? validation(value) : false
    }
    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: !!valid,
                            validation: !!validation,
                            required,
                            value,
                            label,
                        },
                    ],
                ])
            )
        })
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
    if (value) {
        $filesList = value
    }
    $: value = $filesList
    $: inlineButtonLabel =
        progress > 0
            ? `${Math.round(progress * 100)}%`
            : $filesList.length == 0
              ? buttonText
              : $filesList[0].filename.slice(0, 5) +
                '...' +
                $filesList[0].filename.slice(-4)
    $: if (JSON.stringify(value) !== JSON.stringify($filesList)) {
        filesList.set(value)
    }
    let clearInput = (e) => {
        if (e?.target?.value) e.target.value = null
    }
</script>

<input
    bind:this={objInput}
    on:click={clearInput}
    accept={allowExt.map(t => `.${t}`).join(',')}
    style="display: none"
    type="file"
    bind:files
/>
{#if type === 'default'}
    <div class="containter">
        {#if label}
            <label for={name}>
                <div class="label_container">
                    <Typography
                        style="margin: 0 0 0 0;"
                        type="caption"
                        color={disabled ? 'grey-300' : 'black'}
                        >{label}</Typography
                    >
                    {#if required && !disabled && (!value || value.length == 0)}
                        <InfoOutline
                            size={16}
                            title="Campo requerido"
                            style="cursor: pointer"
                        />
                    {/if}
                </div>
            </label>
        {/if}
        <div
            class="box"
            style={`padding: ${
                $filesList?.length === 0 && !upload ? '32px' : '13px 22px'
            }; ${style}`}
        >
            {#if ($filesList || [])?.length === 0 && !upload}
                <img width="60" height="60" alt="" src={Picture} />
                <Typography type="subhead" color="grey-800">{legend}</Typography
                >
                <Button
                    label={buttonText}
                    {disabled}
                    on:click={loadFile}
                    size="small"
                />
            {:else}
                {#each $filesList as itemFile, i (i)}
                    <InputFileItem
                        progress={1}
                        {preview}
                        on:delete={deleteItemBuilder(itemFile.id)}
                        on:preview={(_) =>
                            window.open(
                                `${API_URL}/download/${itemFile.fileId
                                    .split('.')
                                    .at(0)}/preview`,
                                itemFile.filename,
                                'width=566,height=800,scrollbars=NO'
                            )}
                        filename={itemFile.filename}
                    />
                {/each}
                {#if upload}
                    <InputFileItem
                        bind:progress
                        deleteable={false}
                        filename={files[0].name}
                    />
                {/if}
            {/if}
        </div>
        {#if multi && $filesList.length > 0 && (maxFiles ? $filesList.length < maxFiles : true)}
            <TertiaryButton
                on:click={(_) => loadFile()}
                icon={AddCircle}
                label={plusButtonLabel}
            />
        {/if}
    </div>
{:else if type === 'button'}
    <Button
        {style}
        label={inlineButtonLabel}
        {disabled}
        on:click={loadFile}
        size="small"
    />
{/if}
{#if !valid && errMsg !== null}
    <Alert type="error" style="margin-top: 15px">{errMsg}</Alert>
{/if}
<input type="hidden" {name} value={JSON.stringify(value)} />

<style>
    .containter {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0;
        align-items: flex-start;
        gap: 12px;
    }
    .box {
        width: 100%;
        display: flex;
        gap: 12px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 32px;
        background: #f6f6f6;
        border: 1px dashed #6f7072;
        border-radius: 8px;
        user-select: none;
    }
</style>
